<template lang="html">
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-6">
          <h1 class="title">Peach tables</h1>
          <figure class="image">
            <img src="static/images/peach/peach_01-highres.jpg" />
          </figure>
        </div>
        <div class="column is-6" style="margin-top: 55px">
          <p class="title">
            The Peach tables combine an appealing organic shape with the sturdy
            presence of solid wood. The smaller table can be used as a side
            table, or it can be moved around to be sat on or to relax your feet
            on top.
          </p>
          <p>
            The simple leg structure makes it easy to knock the tables down for
            flatpack transport and storage. The name Peach draws inspiration
            from the lush, rounded shape of the fruit, reflected in the gentle
            curves of the tabletops. The sympathetic character of the tables
            comes from the straightforward use of solid wood and the slightly
            unconventional shapes of the leg and the top. The tables are simple
            enough to suit a variety of spaces, from homes to public spaces, but
            still have a strong character to catch the eye. The prototypes were
            crafted by local carpenters using locally sourced elm.
          </p>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/peach/peach_02-highres.jpg" />
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/peach/peach_03-highres.jpg" />
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import mediumZoom from 'medium-zoom'

export default {
  mounted () {
    mediumZoom('.zoom-default')
  }
}
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// src/components/portfolio/work/Peach.vue